/**
 * How the app's AI agent is NAMED to the user.
 *
 * Which CLI engine actually runs a turn (Claude Code, Codex, …) is an
 * implementation choice the user makes in Settings — everywhere the agent
 * speaks or is listed as the author of work, it is Twasta's agent, not the
 * vendor's. One constant so the product never half-renames itself.
 */
export const AGENT_DISPLAY_NAME = 'Twasta Agent'

/** Engine id → what to show for it. Empty string = show nothing. */
const ENGINE_LABEL: Record<string, string> = {
  claude: AGENT_DISPLAY_NAME,
  claude_code: AGENT_DISPLAY_NAME,
  codex: AGENT_DISPLAY_NAME,
  opencode: AGENT_DISPLAY_NAME,
  gemini: AGENT_DISPLAY_NAME,
  // The in-process planner isn't a separate agent to the user.
  autoagent: '',
}

/** Business-facing name for the engine that ran a plan/turn. */
export function agentEngineLabel(engine?: string | null): string {
  const key = (engine || '').trim().toLowerCase()
  if (!key) return ''
  return ENGINE_LABEL[key] ?? AGENT_DISPLAY_NAME
}
